/**
 * Deep-partial MUI theme overrides. This app does not depend on MUI.
 * The key and event match `@atlas-sp/aga-common-lib/theme` and aga-components v2.
 */
export type FederatedThemeOverrides = Record<string, unknown>;

export const FEDERATED_THEME_EVENT = 'aga:federated-theme-change';

type FederatedThemeWindow = Window & {
  __federatedAtlasTheme?: FederatedThemeOverrides;
};

/** True when the selected aga-components remote is the v2 build. */
export function isAgaComponentsV2Selection(version: string | undefined, baseUrl?: string): boolean {
  if (version === 'v2') {
    return true;
  }
  if (!baseUrl) {
    return false;
  }
  const path = baseUrl.split('?')[0].replace(/\/$/, '');
  return path.endsWith('/v2');
}

export function publishFederatedTheme(overrides: FederatedThemeOverrides | undefined): void {
  if (typeof window === 'undefined') {
    return;
  }
  const win = window as FederatedThemeWindow;
  if (win.__federatedAtlasTheme === overrides) {
    return;
  }
  win.__federatedAtlasTheme = overrides;
  window.dispatchEvent(new Event(FEDERATED_THEME_EVENT));
}
